import { fetchCrmObjectProperties } from '../../../routines/integrations/crmRoutines';

const initialState = {
  dealProperties: [],
  companyProperties: [],
  contactProperties: [],
  activityTypeProperties: [],
  pipelines: [],
  propertyFetchLoading: true,
  error: false,
};

const crmPropertyReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchCrmObjectProperties.TRIGGER: {
      return {
        ...state,
        propertyFetchLoading: true,
        error: null,
      };
    }

    case fetchCrmObjectProperties.SUCCESS: {
      const {
        dealProperties,
        companyProperties,
        pipelines,
        contactProperties,
        activityTypeProperties,
      } = action.payload;
      return {
        ...state,
        propertyFetchLoading: false,
        dealProperties,
        companyProperties,
        pipelines,
        contactProperties,
        activityTypeProperties,
      };
    }
    default:
      return state;
  }
};

export default crmPropertyReducer;
